export default __webpack_public_path__ + "static/media/InitialContact.f7cc3a20.png";